import { NgModule, Type } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { SUBSCRIPTION_PRODUCTS_FEATURE_KEY } from './products/products.state';
import { productsReducer } from './products/products.reducer';
import {
  CheckoutSuccessEffects,
  LoadCurrentSubscriptionEffects,
  LoadProductsEffects,
} from './effects';
import { CURRENT_SUBSCRIPTION_FEATURE_KEY } from './current/current.state';
import { currentSubscriptionReducer } from './current/current.reducer';
import {
  SUBSCRIPTION_FEATURE_KEY,
  SubscriptionState,
} from './subscription.state';

export const subscriptionStore: ActionReducerMap<SubscriptionState> = {
  [SUBSCRIPTION_PRODUCTS_FEATURE_KEY]: productsReducer,
  [CURRENT_SUBSCRIPTION_FEATURE_KEY]: currentSubscriptionReducer,
};

export const subscriptionEffects: Type<unknown>[] = [
  LoadProductsEffects,
  LoadCurrentSubscriptionEffects,
  CheckoutSuccessEffects,
];

@NgModule({
  imports: [
    StoreModule.forFeature(SUBSCRIPTION_FEATURE_KEY, subscriptionStore),
    EffectsModule.forFeature(subscriptionEffects),
  ],
})
export class SubscriptionStoreModule {}
